






























































import Translation from '@/mixins/Translation'
import StatusImg from '@/components/image/StatusImg.vue'
import {
  Component, Mixins, Prop, Watch,
} from 'vue-property-decorator'
import {Drawer, Container, Footer, Main, Header} from 'element-ui'

@Component({
  components: {
    StatusImg,
    [Drawer.name]: Drawer,
    [Header.name]: Header,
    [Main.name]: Main,
    [Footer.name]: Footer,
    [Container.name]: Container,
  },
})

export default class DialogDrawer extends Mixins(Translation) {
  @Prop({default: false, type: Boolean}) value: boolean
  @Prop({default: 'dialog.footer', type: String}) translation: string
  @Prop({default: null, type: String}) header: string
  @Prop({default: null, type: String}) title: string
  @Prop({default: null, type: String}) description: string
  @Prop({default: null, type: String}) descriptionVhtml: string
  @Prop({default: 'auto', type: String}) size: string
  @Prop({default: null, type: String}) status: string | null
  @Prop({default: false, type: Boolean}) showCancel: boolean
  @Prop({default: 'confirm', type: String}) confirmText: string
  @Prop({default: 'cancel', type: String}) cancelText: string
  @Prop({default: true, type: Boolean}) wrapperClosable: string

  open: boolean = true

  @Watch('value', {immediate: true})
  __value(value) {
    this.open = value
  }

  onChange(value: boolean) {
    this.open = value
    this.$emit('input', value)
  }

  onClick(confirmResult) {
    this.$emit('close', confirmResult)
    this.onChange(false)
  }
}
